import rock from "../assets/The_rock.jpeg";
import nadal from "../assets/nadal1.jpeg";
import cena from "../assets/John-Cena.webp";
import ronaldo from "../assets/cristiano.jpeg";
import wolf from "../assets/Wolf.jpeg";
import tom from "../assets/Tom_Brady.jpeg";
import tor from "../assets/tor.jpeg";
import federar from "../assets/federer.jpeg";
import michel from "../assets/michel.jpeg";
import ggg from "../assets/GGG.jpeg";
import shafkat from "../assets/shafkat.jpeg";
import jason from "../assets/jason2.jpeg";
import conor from "../assets/conor.jpeg";
import ping from "../assets/LeBron.jpeg";
import Aidar from "../assets/Aiddd.jpeg";
import george from "../assets/georges.jpeg";
import stephen from "../assets/stef.jpeg";
import hannamen from "../assets/han.jpeg";
import jenson from "../assets/jenson.jpeg";
import boyka from "../assets/boyka.jpeg";
import cent from "../assets/50cent2.jpeg";
import king from "../assets/LeBron.jpeg";
import hardy from "../assets/Hardy.jpeg";
import bodegas from "../assets/bodegas.jpeg";
export const persons = [
  {
    name: "Dwayne Johnson",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: rock,
    id: "62dbba7b33e9824a27975b61",
    trainings: [
      {
        day: "Monday",
        trainday: "Chest & Shoulders",
        warmup: "5 min warm up / 50 min steady pace / 5 min cool-down",
        myTrain: [
          {
            trainname: "Dumbbell Incline press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Both Arms",
            },
          },
          {
            trainname: "Dumbbell Incline press",
            quantity: {
              sets: "2",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Alternating",
            },
          },
          {
            trainname: "Chest Flys with Dumbbells",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "FlatBench",
            },
          },
          {
            trainname: "Dumbbell Bench press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Both Arms",
            },
          },
          {
            trainname: "Dumbbell Bench press",
            quantity: {
              sets: "2",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Alternating",
            },
          },
          {
            trainname: "Seated Overhead Press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Dumbbells",
            },
          },
          {
            trainname: "Dumbbell Front Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Dumbbell Side Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Bent-Over Lateral Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Cable Flys",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "00secs",
              notes: "Superset",
            },
          },
          {
            trainname: "Dips Until Failure",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Superset",
            },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Legs & Back",
        warmup: "5 min warm up / 50 min steady pace / 5 min cool-down",
        myTrain: [
          {
            trainname: "Seated Leg Presses",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Lying Leg Curls",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Smith Machine Lunges",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Stiff-Legged Deadlifts",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Box Jumps",
            quantity: { sets: "3", reps: "20", rest: "45secs" },
          },
          {
            trainname: "Calf raises",
            quantity: { sets: "3", reps: "20", rest: "45secs" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Lat pull-downs",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Wide Grip",
            },
          },
          {
            trainname: "Lat pull-downs 2",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Narrow Grip",
            },
          },
          {
            trainname: "Seated Pulley Rows",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: {
              sets: "3",
              reps: "10-12",
              rest: "45secs",
              notes: "Dumbbells",
            },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Arms & Abs",
        warmup:
          "1 hour Cardio on Elliptical / StairMaster: 30 min steady pace on each",
        myTrain: [
          {
            trainname: "Triceps Push-downs",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "Normal Grip",
            },
          },
          {
            trainname: "Triceps Push-downs",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "Narrow Grip",
            },
          },
          {
            trainname: "Lying Tricep Skullcrushers",
            quantity: { sets: "3-4", reps: "8-12", rest: "45secs" },
          },
          {
            trainname: "Barbell Bicep Curls",
            quantity: { sets: "3-4", reps: "8-12", rest: "45secs" },
          },
          {
            trainname: "Preacher Curls",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "machine",
            },
          },
          {
            trainname: "Dumbbell Hammer Curls",
            quantity: {
              sets: "3",
              reps: "20",
              rest: "45secs",
              notes: "alternating",
            },
          },
          {
            trainname: "Double Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
          {
            trainname: "Bicycle Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
          {
            trainname: "Reverse Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Chest & Shoulders",
        warmup: "5 min warm up / 50 min steady pace / 5 min cool-down",
        myTrain: [
          {
            trainname: "Dumbbell Incline press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Both Arms",
            },
          },
          {
            trainname: "Dumbbell Incline press",
            quantity: {
              sets: "2",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Alternating",
            },
          },
          {
            trainname: "Chest Flys with Dumbbells",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "FlatBench",
            },
          },
          {
            trainname: "Dumbbell Bench press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Both Arms",
            },
          },
          {
            trainname: "Dumbbell Bench press",
            quantity: {
              sets: "2",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Alternating",
            },
          },
          {
            trainname: "Seated Overhead Press",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Dumbbells",
            },
          },
          {
            trainname: "Dumbbell Front Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Dumbbell Side Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Bent-Over Lateral Raises",
            quantity: { sets: "4", reps: "Pyramid", rest: "45secs" },
          },
          {
            trainname: "Cable Flys",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "00secs",
              notes: "Superset",
            },
          },
          {
            trainname: "Dips Until Failure",
            quantity: {
              sets: "4",
              reps: "Pyramid",
              rest: "45secs",
              notes: "Superset",
            },
          },
        ],
      },
      {
        day: "Saturday",
        trainday: "Arms & Abs",
        warmup:
          "1 hour Cardio on Elliptical / StairMaster: 30 min steady pace on each",
        myTrain: [
          {
            trainname: "Triceps Push-downs",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "Normal Grip",
            },
          },
          {
            trainname: "Triceps Push-downs",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "Narrow Grip",
            },
          },
          {
            trainname: "Lying Tricep Skullcrushers",
            quantity: { sets: "3-4", reps: "8-12", rest: "45secs" },
          },
          {
            trainname: "Barbell Bicep Curls",
            quantity: { sets: "3-4", reps: "8-12", rest: "45secs" },
          },
          {
            trainname: "Preacher Curls",
            quantity: {
              sets: "3-4",
              reps: "8-12",
              rest: "45secs",
              notes: "machine",
            },
          },
          {
            trainname: "Dumbbell Hammer Curls",
            quantity: {
              sets: "3",
              reps: "20",
              rest: "45secs",
              notes: "alternating",
            },
          },
          {
            trainname: "Double Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
          {
            trainname: "Bicycle Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
          {
            trainname: "Reverse Crunches",
            quantity: { sets: "3", reps: "25", rest: "45secs" },
          },
        ],
      },
    ],
  },
  {
    name: "Hunnam Charlie",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: hannamen,
    id: "62dbba7b33e9824a27975b62",

    trainings: [
      {
        day: "Monday",
        warmup: "Stretch",
        trainday: "Full Body Workout",
        myTrain: [
          {
            trainname: "Wide-Grip Pull-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Squats",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Military Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Chin-Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Decline Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Focused Ab Exercises",
            quantity: { sets: "20min" },
          },
        ],
      },
      {
        day: "Tuesday",
        warmup: "Stretch",
        trainday: "Full Body Workout",
        myTrain: [
          {
            trainname: "Wide-Grip Pull-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Squats",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Military Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Chin-Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Decline Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Focused Ab Exercises",
            quantity: { sets: "20min" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "HIIT, and Cardio",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Running at 10 mph or faster",
            quantity: { sets: "15min" },
          },
          {
            trainname: "High-Intensity Elliptical",
            quantity: { sets: "15min" },
          },
          {
            trainname: "High-Intensity Interval Training",
            quantity: { sets: "25min" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Full-Body Workout",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Squats",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Wide Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Standing Dumbbell Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Parallel-Bar Dips",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Reverse-Grip Pull-Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Hanging Knee Raises",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Lying Leg Lifts",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Plank",
            quantity: { sets: "3 min" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Full-Body Workout",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Squats",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Wide Push-Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Standing Dumbbell Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Parallel-Bar Dips",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Reverse-Grip Pull-Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Hanging Knee Raises",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Lying Leg Lifts",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Plank",
            quantity: { sets: "3 min" },
          },
        ],
      },
    ],
  },
  {
    name: "Jason Statham",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: jason,
    trainings: [
      {
        day: "Monday",
        warmup: "Row 10-20 minutes",
        trainday: "Full Body Workout",
        myTrain: [
          {
            trainname: "Dips",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Air Squats",
            quantity: { sets: "5", reps: "15" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Burpees",
            quantity: { sets: "3", reps: "10" },
            notes: "Circuit",
          },
          {
            trainname: "Lunges",
            quantity: { sets: "3", reps: "12" },
            notes: "Circuit",
          },
          {
            trainname: "Hanging Leg Raises",
            quantity: { sets: "3", reps: "15" },
            notes: "Circuit",
          },
          {
            trainname: "Clap Push Ups",
            quantity: { sets: "3", reps: "20" },
            notes: "Circuit",
          },
          {
            trainname: "Hanging Leg Raisess",
            quantity: { sets: "3", reps: "15" },
            notes: "Circuit",
          },
          {
            trainname: "Lunges",
            quantity: { sets: "3", reps: "12" },
            notes: "Circuit",
          },
        ],
      },
      {
        day: "Tuesday",
        warmup: "Stretch",
        trainday: "Full Body Workout",
        myTrain: [
          {
            trainname: "Dips",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "5", reps: "10" },
          },

          {
            trainname: "Air Squats",
            quantity: { sets: "5", reps: "15" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Run",
            quantity: { sets: "5", reps: "400m" },
            notes: "Circuit",
          },
          {
            trainname: "Dips",
            quantity: { sets: "5", reps: "15" },
            notes: "Circuit",
          },
          {
            trainname: "One Legged Squats",
            quantity: { sets: "5", reps: "10" },
            notes: "Circuit",
          },
          {
            trainname: "Man Makers",
            quantity: { sets: "5", reps: "5" },
            notes: "Circuit",
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Full-Body Workout",
        warmup: "Row 10-20 minutes",
        myTrain: [
          {
            trainname: "Dips",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Air Squats",
            quantity: { sets: "5", reps: "15" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Muscle Ups",
            quantity: { sets: "3", reps: "3" },
            notes: "Circuit",
          },
          {
            trainname: "Burpees",
            quantity: { sets: "3", reps: "5" },
            notes: "Circuit",
          },
          {
            trainname: "Jump Ropes",
            quantity: { sets: "3", reps: "100" },
            notes: "Circuit",
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "3", reps: "10" },
            notes: "Circuit",
          },
          {
            trainname: "Jump Ropes",
            quantity: { sets: "3", reps: "100" },
            notes: "Circuit",
          },
          {
            trainname: "Burpees",
            quantity: { sets: "3", reps: "5" },
            notes: "Circuit",
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Full-Body Workout",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Dips",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Air Squats",
            quantity: { sets: "5", reps: "15" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Jog",
            quantity: { sets: "5", reps: "800m" },
            notes: "Circuit",
          },
          {
            trainname: "Mountain Climbers",
            quantity: { sets: "5", reps: "25" },
            notes: "Circuit",
          },
          {
            trainname: "V Ups",
            quantity: { sets: "5", reps: "15" },
            notes: "Circuit",
          },
          {
            trainname: "Plank to Push Ups",
            quantity: { sets: "5", reps: "10" },
            notes: "Circuit",
          },
        ],
      },
    ],
  },
  {
    name: "50 Cent",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: cent,
    trainings: [
      {
        day: "Monday",
        trainday: "Core Workout",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Crunches",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Leg raises",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Russian twist with dumbbel",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Scissor kicks",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Plank twister",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Plank hold",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Side plank to a crunch",
            quantity: { sets: "4", reps: "10" },
          },
        ],
      },
      {
        day: "Tuesday",
        warmup: "20 Minute Low Intensity Incline Walk",
        trainday: "Arms & Chest Day",
        myTrain: [
          {
            trainname: "Flat bench press",

            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Incline bench press",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Dumbbell press",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Cable flyes",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Low cable flyes",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Chest dips",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 1",
          },
          {
            trainname: "Chest dips",
            quantity: { sets: "4", reps: "15" },
          },
          {
            trainname: "Wide grip lat pulldowns",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "Cable rows",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "Dumbbell rows",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "Inverted rows",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "Bent over rows",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "T-bar rows",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
          {
            trainname: "Deadlifts",
            quantity: { sets: "4", reps: "15" },
            notes: "Circuit 2",
          },
        ],
      },
      {
        day: "Wedneday",
        trainday: "Cardio day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Battle rope",
            quantity: { sets: "10min" },
          },
          {
            trainname: "Run with sprint intervals",
            quantity: { sets: "3-4 mile" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Leg & Glutes Day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Squats",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hack squats",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Leg press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Lunges",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Leg extension to curls",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hip thuster",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hip extension",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Calf raises",
            quantity: { sets: "4", reps: "12" },
          },
        ],
      },
      {
        day: "Saturday",
        trainday: "Full body strength Day",
        warmup: "Stationary exercise bike for 10 minutes",
        myTrain: [
          {
            trainname: "Squats",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Puch ups",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Dumbbell rows",
            quantity: { sets: "4", reps: "15" },
          },
          {
            trainname: "Crunches",
            quantity: { sets: "4", reps: "20" },
          },
          {
            trainname: "Lunges",
            quantity: { sets: "4", reps: "20" },
          },
          {
            trainname: "Farmer walks",
            quantity: { sets: "4", reps: "20" },
          },
        ],
      },
    ],
  },
  {
    name: "Lebron James",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: king,
    id: "62e6d4f425b6e6253c1cd759",
    trainings: [
      {
        day: "Monday",
        warmup: "StairMaster or VersaClimber 20-30 Minutes",
        trainday: "Chest, Tris, Shoulders/ Stretch/Yoga Cooldown",
        myTrain: [
          {
            trainname: "Incline Bench Press w/ DB",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Seated DB Overhead Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Seated Overhead Tricep Extension w/ One DB",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Clap Push-Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Triangle Push Ups ",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Plank to Push Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Yoga",
            quantity: { sets: "15-30 minutes" },
          },
        ],
      },
      {
        day: "Wednesday",
        warmup: "Back, Bis, Traps and VersaClimber w/ Stretch/Yoga Cooldown",
        trainday: "Full Body Workout",
        myTrain: [
          {
            trainname: "Barbell Deadlift",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Standing Bicep Curls w/ Barbell",
            quantity: { sets: "4", reps: "12" },
          },

          {
            trainname: "Barbell Bent Over Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Wide Push Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Chin Ups ",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Wide Grip Pull Ups",
            quantity: { sets: "3", reps: "10" },
            notes: "Circuit",
          },
          {
            trainname: "Yoga",
            quantity: { sets: "15-30 minutes" },
            notes: "Circuit",
          },
          {
            trainname: "Man Makers",
            quantity: { sets: "5", reps: "5" },
            notes: "Circuit",
          },
        ],
      },
      {
        day: "Friday",
        trainday:
          "Legs, Calves, Explosiveness and VersaClimber w/ Stretch/Yoga Cooldown",
        warmup: "Row 10-20 minutes",
        myTrain: [
          {
            trainname: "Back Squat",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Seated Calf Raise",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jumping Lunges",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Box Jumps",
            quantity: { sets: "3", reps: "15" },
            notes: "Circuit",
          },
          {
            trainname: "Weighted Jumps",
            quantity: { sets: "3", reps: "10" },
            notes: "Circuit",
          },
          {
            trainname: "Yoga",
            quantity: { sets: "15-30 min" },
            notes: "Circuit",
          },
        ],
      },
    ],
  },
  // {
  //   name: "Michael Phelps",

  //   position: [
  //     { label: "actor", color: "green" },
  //     { label: "activist", color: "#f4b52e" },
  //   ],
  //   icon: michel,

  {
    name: "Scott Adkins",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: boyka,
    id: "62dbbc6026cfe9baa5174cda",
    trainings: [
      {
        day: "Monday",
        trainday: "Chest and Triceps",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Bench Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Incline Bench Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Overhead Tricep Extension",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Chest Flys",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Tricep Cable Pushdowns",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "3", reps: "25" },
          },
          {
            trainname: "Kick Backs",
            quantity: { sets: "3", reps: "12" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Cardio/MMA Day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Swapping in and out",
            quantity: { sets: "60min" },
          },
          {
            trainname: "Treadmill",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "sprint 6-10mph and 1 min off = walk 2.5-3.5mph",
            },
          },
          {
            trainname: "Bike",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "1 min on = over 100 RPMs at level 10 and 1 min off = steady lower RPMs at level 3-5",
            },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Back and Biceps",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Deadlift",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Dumbbell Bicep Curls",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Cable Rows",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Preacher Curls",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Wide Grip Pull Ups",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Hammer Curls",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Lateral Pulldowns",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Barbell Bentover Rows",
            quantity: { sets: "3", reps: "12" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Cardio/MMA Day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Swapping in and out",
            quantity: { sets: "60min" },
          },
          {
            trainname: "Treadmill",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "sprint 6-10mph and 1 min off = walk 2.5-3.5mph",
            },
          },
          {
            trainname: "Bike",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "1 min on = over 100 RPMs at level 10 and 1 min off = steady lower RPMs at level 3-5",
            },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Legs and Shoulders",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Military Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Arnold Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Hamstring Curls",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Shoulder Front Raise",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Calf Raises",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Shrugs",
            quantity: { sets: "3", reps: "12" },
          },
        ],
      },
      {
        day: "Saturday",
        trainday: "Cardio/MMA Day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Swapping in and out",
            quantity: { sets: "60min" },
          },
          {
            trainname: "Treadmill",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "sprint 6-10mph and 1 min off = walk 2.5-3.5mph",
            },
          },
          {
            trainname: "Bike",
            quantity: {
              sets: "1 min on 1 min off",
              reps: "1 min on = over 100 RPMs at level 10 and 1 min off = steady lower RPMs at level 3-5",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Hugh Jackman",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: wolf,
    id: "62e6785c25b6e6253c1cd754",
    trainings: [
      {
        day: "Monday",
        trainday: "Chest day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Barbell Bench Press",
            quantity: { sets: "5", reps: "10-8-5-3-1" },
          },
          {
            trainname: "Cable Crossovers",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Chest Press Machine",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Incline Dumbbell Press and Dumbbell Hex Press",
            quantity: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
          {
            trainname: "Dumbbell Chest Flys and Dips",
            quantity: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Back Day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Deadlift",
            quantity: { sets: "5", reps: "10-8-5-3-1" },
          },
          {
            trainname: "Lateral Pull Downs",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbell Rows and Wide Grip Pull Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Back Extension and Push Ups",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Wedneday",
        trainday: "Shoulders and Traps day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Military Press",
            quantity: { sets: "5", reps: "10-8-5-3-1" },
          },
          {
            trainname: "Shoulder Front Raises",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Arnold Presses and Pull Ups",
            quantity: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
          {
            trainname: "Face Pulls (Cable) and Shoulder Flys",
            bench1: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Arms Day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Preacher Curls",
            quantity: { sets: "5", reps: "10-8-5-3-3" },
          },
          {
            trainname: "Close Grip Bench Press",
            quantity: { sets: "5", reps: "10-8-5-3-3" },
          },
          {
            trainname: "Dumbbell Bicep Curls",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Overhead Tricep Extension",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Cable EZ Bar Curls and Cable Hammer Curls",
            quantity: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
          {
            trainname: "Cable Tricep Push Downs and Triangle Push Ups",
            quantity: { sets: "3", reps: "10" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Legs Day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Squats",
            quantity: { sets: "5", reps: "10-8-5-3-1" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "12-10-8" },
          },
          {
            trainname: "Weighted Lunges and Straight Leg Deadlift",
            quantity: { sets: "3", reps: "12" },
            notes:
              "Do not break in between sets for a superset. Finish both exercises then break before repeating",
          },
        ],
      },
    ],
  },
  {
    name: "Cristiano Ronaldo",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: ronaldo,
    id: "62e6e6c125b6e6253c1cd75c",
    day: "Monday",
    trainings: [
      {
        day: "Monday",
        trainday: "Cardio, Circuit, Chest, Sprints day",
        warmup: "Stretch / Jog 1600m",
        myTrain: [
          {
            trainname: "Thrusters",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Box Jumps",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Bench Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Chest Flys",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Incline Chest Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Cable Pushdowns",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { sets: "1", reps: "10-20min" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Cardio, Circuit, Legs, Sprints Day",
        warmup: "Stretch / Jog 1600m",
        myTrain: [
          {
            trainname: "Bike",
            quantity: { sets: "1", reps: "60 cals" },
          },
          {
            trainname: "Wall Balls",
            quantity: { sets: "1", reps: "50" },
          },
          {
            trainname: "Power Cleans",
            quantity: { sets: "1", reps: "40" },
          },
          {
            trainname: "One Arm Dumbbell Snatches",
            quantity: { sets: "1", reps: "30" },
          },
          {
            trainname: "Burpees",
            quantity: { sets: "1", reps: "20" },
          },
          {
            trainname: "Deadlifts",
            quantity: { sets: "1", reps: "10" },
          },
          {
            trainname: "Back Squat",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Quad Extension",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hamstring Curls",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { sets: "1", reps: "10-20min" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Cardio, Circuit, Back, Sprints",
        warmup: "Stretch / Jog 1600m",
        myTrain: [
          {
            trainname: "Burpees",
            quantity: { sets: "3", reps: "5" },
          },
          {
            trainname: "Push Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Sit Ups",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Power Snatches",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Mountain Climbers",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Pistol Squats (Each Leg)",
            quantity: { sets: "3", reps: "5" },
          },
          {
            trainname: "Deadlift",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Lateral Pulldowns",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { sets: "1", reps: "10-20min" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Cardio, Circuit, Shoulders, Sprints Day",
        warmup: "Stretch / Jog 1600m",
        myTrain: [
          {
            trainname: "Thrusters",
            quantity: { sets: "3", reps: "21-15-9" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "3", reps: "21-15-9" },
          },
          {
            trainname: "Military Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Front Raises",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Lateral Side Raises",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Upright Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { sets: "1", reps: "10-20min" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Cardio, Circuit, Freestyle, Sprints",
        warmup: "Stretch / Jog 1600m",
        myTrain: [
          {
            trainname: "Row",
            quantity: { sets: "4", reps: "800" },
          },
          {
            trainname: "Power Cleans",
            quantity: { sets: "4", reps: "15" },
          },
          {
            trainname: "Bench Press",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Burpees",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Clean and Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Weighted Lunges",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Box Jumps",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { sets: "1", reps: "10-20min" },
          },
        ],
      },
    ],
  },
  {
    name: "Zac Efron",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: tom,
    id: "62e6dca225b6e6253c1cd75a",
    trainings: [
      {
        day: "Monday",
        trainday: "Chest and Triceps day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Flat Bench Press (Barbell)",
            quantity: { sets: "5", reps: "10-8-5-5-3" },
          },
          {
            trainname: "Tricep Push Downs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Tricep Overhead Extensions",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Incline Dumbbell Chest Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Front Chest Raises",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Skull Crushers",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Chest Cable Flyes",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "15" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Circuit Training Day",
        warmup: "10 Pull Ups / 15 Air Squats / 20 Push Ups",
        myTrain: [
          {
            trainname: "Pull Ups",
            quantity: { reps: "25" },
          },
          {
            trainname: "Deadlifts",
            quantity: { weight: "135", reps: "50" },
          },
          {
            trainname: "Push Ups",
            quantity: { reps: "50" },
          },
          {
            trainname: "Box Jumps",
            quantity: { reps: "50" },
          },
          {
            trainname: "One Arm Snatches",
            quantity: { weight: "30lbs/13kg", reps: "50" },
          },
          {
            trainname: "Goblet Squats",
            quantity: { weight: "25-45lbs/11-20kg", reps: "50" },
          },
          {
            trainname: "Clean and Presses",
            quantity: { weight: "45lbs/20kg", reps: "50" },
          },
          {
            trainname: "Pull Ups",
            quantity: { reps: "25" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Shoulders and Legs day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "5", reps: "10-8-5-5-3" },
          },
          {
            trainname: "Military Press",
            quantity: { sets: "5", reps: "10-8-5-5-3" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Shoulder Front Raises",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Leg Extension Machine",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Arnold Presses",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Circuit Training Day",
        warmup: "10 Pull Ups / 15 Air Squats / 20 Push Ups",
        myTrain: [
          {
            trainname: "Pull Ups",
            quantity: { reps: "25" },
          },
          {
            trainname: "Deadlifts",
            quantity: { weight: "135", reps: "50" },
          },
          {
            trainname: "Push Ups",
            quantity: { reps: "50" },
          },
          {
            trainname: "Box Jumps",
            quantity: { reps: "50" },
          },
          {
            trainname: "One Arm Snatches",
            quantity: { weight: "30lbs/13kg", reps: "50" },
          },
          {
            trainname: "Goblet Squats",
            quantity: { weight: "25-45lbs/11-20kg", reps: "50" },
          },
          {
            trainname: "Clean and Presses",
            quantity: { weight: "45lbs/20kg", reps: "50" },
          },
          {
            trainname: "Pull Ups",
            quantity: { reps: "25" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Legs and Shoulders Day",
        warmup: "20 Minute Low Intensity Incline Walk",
        myTrain: [
          {
            trainname: "Deadlift",
            quantity: { sets: "5", reps: "10-8-5-5-3" },
          },
          {
            trainname: "Bicep Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Lateral Pull Down Machine",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Hammer Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Pull Ups",
            quantity: { sets: "3", reps: "15" },
          },
        ],
      },
    ],
  },
  {
    name: "Tom Hardy",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: hardy,

    trainings: [
      {
        day: "Monday",
        trainday: "Back and Traps day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Lateral Pulldowns",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Wide Grip Barbell Shrugs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Shrugs",
            quantity: { sets: "6", reps: "10-8-5-5-3-Max" },
          },
          {
            trainname: "Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Wide Grip Pull Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Deadlifts",
            quantity: { sets: "6", reps: "10-8-5-5-3-Max" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Chest Day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Push Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Wide Grip Push Ups",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Dumbbell Bench Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Flyes",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Cable Flyes",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Incline Cable Flyes",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Barbell Bench Press",
            quantity: { sets: "6", reps: "10-8-5-5-3-Max" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Arms day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Dumbbell Bicep Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Hammer Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Push Downs (Cable)",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Kick-Backs (Cable)",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Chin Ups",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Skull Crushers",
            quantity: { sets: "5", reps: "10" },
          },
          {
            trainname: "Preacher Curls",
            quantity: { sets: "5", reps: "10" },
          },
        ],
      },
      {
        day: "Satuday",
        trainday: "Legs and Shoulders Day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Dumbbell Shoulder Raises",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Calf Raises",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Shrugs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Weighted Lunges",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Barbell Shoulder Raises",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Squats",
            quantity: { sets: "5", reps: "8-5-5-3-Max" },
          },
          {
            trainname: "Military Press",
            quantity: { sets: "6", reps: "10-8-5-5-3-Max" },
          },
        ],
      },
    ],
  },
  {
    name: "John Cena",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: cena,
    id: "62e7026425b6e6253c1cd75d",
    trainings: [
      {
        day: "Monday",
        trainday: "Upper Body day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Clean and Jerk",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Snatch",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Kettlebell Swings",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Hang Cleans",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "One Arm Dumbbell Snatch",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "One Arm Kettlebell Deadlifts",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Legs and Calves",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Back Squat",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "12" },
          },
          {
            trainname: "Seated Calf Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Front Squat",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Hamstring Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Leg Extension",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Hack Squat",
            quantity: { sets: "4", reps: "12" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Chest and Triceps",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Bench Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Pause Bench",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Pec Dec",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Overhead Tricep Extension",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Skull Crushers",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Incline Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Deadlift",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Lateral Pulldowns",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Jump Rope",
            quantity: { reps: "10-20min" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Back and Biceps day",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Deadlift",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Preacher Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Standing Bicep Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Lateral Pulldowns",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Seated Dumbbell Bicep Curl",
            overhead: { sets: "3", reps: "10" },
          },
          {
            trainname: "Front Pulldown Machine",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Shoulders and Traps",
        warmup: "Stretch",
        myTrain: [
          {
            trainname: "Military Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Shoulder Front Raise",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Shoulder Flys",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dumbbell Shrugs",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Arnold Press",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Facepulls",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
    ],
  },
  {
    name: "Chris Hemsworth",
    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: tor,
    id: "62e66f4f25b6e6253c1cd753",
    trainings: [
      {
        day: "Monday",
        trainday: "Back day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Pull ups",
            quantity: { sets: "5", reps: "20-15-12-10-10" },
          },
          {
            trainname: "Wide Grip Push ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Hammer Strength 2 Arm Row",
            quantity: { sets: "5", reps: "12" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hyperextension",
            quantity: { sets: "4", reps: "25-20-15-15" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Chest Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bench Press",
            quantity: { sets: "8", reps: "12-10-10-8-8-6-4-4-4" },
          },
          {
            trainname: "Incline Dumbbell Bench Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hammer Strength Chest Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Weighted Dips",
            quantity: { sets: "4", reps: "10" },
          },
          {
            trainname: "Cable Flys",
            quantity: { sets: "4", reps: "12" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Leg Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "1", reps: "Max" },
          },
          {
            trainname: "Lunges",
            quantity: { sets: "4", reps: "20" },
          },
          {
            trainname: "Leg Extension",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Shoulder Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Military Press",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Arnold Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Lateral Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Dumbbell Front Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Rear Delt Flys",
            quantity: { sets: "3", reps: "15" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Arm Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bicep Curl",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Skull Crushers:",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Barbell Reverse Wrist Curl",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
    ],
  },
  {
    name: "Aidar Nugmanoff",

    position: [
      { label: "actor", color: "green" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: Aidar,
    trainings: [
      {
        day: "Monday",
        trainday: "Back day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Pull ups",
            quantity: { sets: "5", reps: "20-15-12-10-10" },
          },
          {
            trainname: "Wide Grip Push ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Hammer Strength 2 Arm Row",
            quantity: { sets: "5", reps: "12" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hyperextension",
            quantity: { sets: "4", reps: "25-20-15-15" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Chest Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bench Press",
            quantity: { sets: "8", reps: "12-10-10-8-8-6-4-4-4" },
          },
          {
            trainname: "Incline Dumbbell Bench Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hammer Strength Chest Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Weighted Dips",
            quantity: { sets: "4", reps: "12" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Leg Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "1", reps: "Max" },
          },
          {
            trainname: "Lunges",
            quantity: { sets: "4", reps: "20" },
          },
          {
            trainname: "Leg Extension",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Shoulder Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Military Press",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Arnold Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Lateral Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Dumbbell Front Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Rear Delt Flys",
            quantity: { sets: "3", reps: "15" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Arm Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bicep Curl",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Skull Crushers:",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Barbell Reverse Wrist Curl",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
    ],
  },
  {
    name: "Georges St-Pierre",

    position: [
      { label: "actor", color: "#8c61ff" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: george,
    trainings: [
      {
        day: "Monday",
        trainday: "Back day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Pull ups",
            quantity: { sets: "5", reps: "20-15-12-10-10" },
          },
          {
            trainname: "Wide Grip Push ups",
            quantity: { sets: "5", reps: "20" },
          },
          {
            trainname: "Hammer Strength 2 Arm Row",
            quantity: { sets: "5", reps: "12" },
          },
          {
            trainname: "Dumbbell Rows",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hyperextension",
            quantity: { sets: "4", reps: "25-20-15-15" },
          },
        ],
      },
      {
        day: "Tuesday",
        trainday: "Chest Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bench Press",
            quantity: { sets: "8", reps: "12-10-10-8-8-6-4-4-4" },
          },
          {
            trainname: "Incline Dumbbell Bench Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Hammer Strength Chest Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Weighted Dips",
            quantity: "Cable Flys",
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Leg Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "1", reps: "Max" },
          },
          {
            trainname: "Lunges",
            quantity: { sets: "4", reps: "20" },
          },
          {
            trainname: "Leg Extension",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
          {
            trainname: "Single Leg-Curls:",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
      {
        day: "Thursday",
        trainday: "Shoulder Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Military Press",
            quantity: { sets: "7", reps: "10-8-6-5-4-3-3" },
          },
          {
            trainname: "Arnold Press",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Barbell Shrugs",
            quantity: { sets: "4", reps: "12" },
          },
          {
            trainname: "Dumbbell Lateral Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Dumbbell Front Raise",
            quantity: { sets: "3", reps: "15" },
          },
          {
            trainname: "Rear Delt Flys",
            quantity: { sets: "3", reps: "15" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Arm Day",
        warmup: "Stretch / 20 minutes of slow incline walk",
        myTrain: [
          {
            trainname: "Barbell Bicep Curl",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Skull Crushers:",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Barbell Reverse Wrist Curl",
            quantity: { sets: "3", reps: "20" },
          },
        ],
      },
    ],
  },
  {
    name: "Jensen Ackles",

    position: [
      { label: "actor", color: "#8c61ff" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: jenson,

    trainings: [
      {
        day: "Monday",
        myTrain: [
          {
            trainday: "Push day",
            warmup: "10 Minute Incline Walk to Get Warm",
            trainname: "Incline Dumbbell Bench Press",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Seated Overhead Press (Dumbbell or Barbell)",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Seated Tricep Overhead Extension (Dumbbell or Cable)",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Kettlebell Swings",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Wednesday",
        myTrain: [
          {
            trainday: "Pull Day",
            warmup: "10 Minute Incline Walk to Get Warm",
            trainname: "Dumbbell Romanian Deadlifts",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "EZ Bar Standing Curls",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Reverse Grip Hammer Strength Pulldowns",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Chin Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Close Grip Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Push Day",
        warmup: "10 Minute Incline Walk to Get Warm",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Hamstring Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Quad Extensions",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Calf Raises",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
    ],
  },
  {
    name: "Jensen Ackles",

    position: [
      { label: "actor", color: "#8c61ff" },
      { label: "activist", color: "#f4b52e" },
    ],
    icon: michel,

    trainings: [
      {
        day: "Monday",
        trainday: "Push day",
        warmup: "10 Minute Incline Walk to Get Warm",
        myTrain: [
          {
            trainname: "Incline Dumbbell Bench Press",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Seated Overhead Press (Dumbbell or Barbell)",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Seated Tricep Overhead Extension (Dumbbell or Cable)",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Dips",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Kettlebell Swings",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Wednesday",
        trainday: "Pull Day",
        warmup: "10 Minute Incline Walk to Get Warm",
        myTrain: [
          {
            trainname: "Dumbbell Romanian Deadlifts",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "EZ Bar Standing Curls",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Reverse Grip Hammer Strength Pulldowns",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Chin Ups",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Close Grip Cable Rows",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
      {
        day: "Friday",
        trainday: "Push Day",
        warmup: "10 Minute Incline Walk to Get Warm",
        myTrain: [
          {
            trainname: "Back Squats",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Leg Press",
            quantity: { sets: "3", reps: "12,10,8" },
          },
          {
            trainname: "Hamstring Curls",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Quad Extensions",
            quantity: { sets: "3", reps: "10" },
          },
          {
            trainname: "Calf Raises",
            quantity: { sets: "3", reps: "10" },
          },
        ],
      },
    ],
  },
];
